export const environment = {
  production: true,
  // API_ENDPOINT: 'https://api.redearth.propertycrm.com.au',
  // API_ENDPOINT: 'http://192.168.1.100:8080',
  // API_ENDPOINT: 'http://192.168.1.115:8080',
  // API_ENDPOINT: 'http://192.168.1.2:8080',
  API_ENDPOINT: '/api',
  PARTNER_NAME: 'Local',
  // API_ENDPOINT: 'http://localhost:8080',
};
